import React, { useState } from 'react';

import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';

import { Resource } from '../../common/constants/resource';
import ConfirmDialog from './ConfirmDialog';

interface ConfirmationDeleteButtonProps {
  dialogTitle: string;
  dialogContentText: string;
  deleteHandler: () => void;
  /**
   * Whether the delete button should be shown. Computed by the caller (e.g.
   * isAdmin(roles), or later useAccess(...)) so the access-check strategy
   * can evolve per caller without changing this shared component.
   */
  canDelete: boolean;
}

const ConfirmationDeleteButton: React.FC<ConfirmationDeleteButtonProps> = ({
  dialogTitle,
  dialogContentText,
  deleteHandler,
  canDelete,
}) => {
  const [showConfirmDeletePopup, setShowConfirmDeletePopup] = useState(false);
  return (
    <>
      {canDelete && (
        <Button
          onClick={() => {
            setShowConfirmDeletePopup(true);
          }}
        >
          <FontAwesomeIcon icon={faTrash} style={{ width: '13px' }} />
        </Button>
      )}
      {showConfirmDeletePopup && (
        <ConfirmDialog
          open={showConfirmDeletePopup}
          onClose={() => setShowConfirmDeletePopup(false)}
          onConfirm={deleteHandler}
          dialogTitle={dialogTitle}
          dialogContentText={dialogContentText}
          cancelText={Resource.CANCEL}
          confirmText={Resource.CONFIRM}
        />
      )}
    </>
  );
};

export default ConfirmationDeleteButton;
